<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 제목 -->
							<th class="col-1">* {{ getMessage_('QWCC001438') }}</th>
							<td class="col-4">
								<el-input
									:value="detailForm.badTitlSbc"
									@input="value => onChangeParam_text('badTitlSbc', value, 150)"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- 첨부파일 -->
							<th>{{ getMessage_('QWCC000039') }}</th>
							<!-- 양품(선택) -->
							<th>{{ getMessage_('QWCC001962') }}</th>
							<!-- 불량품(필수) -->
							<th>* {{ getMessage_('QWCC001963') }}</th>
						</tr>
						<tr>
							<!-- 불량내용 -->
							<th>* {{ getMessage_('QWCC001387') }}</th>
							<td>
								<el-input
									type="textarea"
									:rows="5"
									:value="detailForm.badSbc"
									@input="value => onChangeParam_text('badSbc', value, 200)"
									:readOnly="getEditChk"
								/>
							</td>
							<td class="col-3 h-100">
								<!-- 불량내용 파일첨부 -->
								<template v-if="isLoaded">
									<file-upload-list
										id="badFile"
										ref="badFileRef"
										width="100%"
										height="100%"
										:propFileList="detailForm.badFileDb"
										:isEditable="!getEditChk"
										maxQuantity="5"
										@MultiFile="fileUpload"
										@onDownload="onDownloadFile"
									></file-upload-list>
								</template>
							</td>
							<!-- 양품(선택) -->
							<td rowspan="1" style="width: 100px">
								<template v-if="isLoaded">
									<img-upload
										ref="normImgFileRef"
										width="100%"
										height="140px"
										:propSrc="normImgFileUrl"
										propSeq="normImgFile"
										:propFileId="detailForm.normImgFileId"
										:isEditable="!getEditChk"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
										@deleteImg="imgDelete"
										:needDupCheck="true"
										@imgDupCheck="imgDupCheck"
									>
									</img-upload>
								</template>
							</td>
							<!-- 불량품(필수) -->
							<td rowspan="1" style="width: 100px">
								<template v-if="isLoaded">
									<img-upload
										ref="badImgFileRef"
										width="100%"
										height="140px"
										:propSrc="badImgFileUrl"
										propSeq="badImgFile"
										:propFileId="detailForm.badImgFileId"
										:isEditable="!getEditChk"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
										@deleteImg="imgDelete"
										:needDupCheck="true"
										@imgDupCheck="imgDupCheck"
									></img-upload>
								</template>
							</td>
						</tr>
						<tr>
							<!-- 비고 -->
							<th>{{ getMessage_('QWCC000906') }}</th>
							<td>
								<el-input v-model="detailForm.rmk1" @input="value => onChangeParam_text('rmk1', value, 100)" :readOnly="getEditChk"/>
							</td>
							<!-- 이력 -->
							<th>{{ getMessage_('SWCC000747') }}</th>
							<td colspan="2">
								<el-input type="textarea" v-model="detailForm.rmkHis" :show-word-limit="true" :rows="3" readOnly />
							</td>
						</tr>
						<!-- <tr>
							<th class="col-1">{{ getMessage_('QWCC001456') }}</th>
							<td colspan="4">
								<el-input
									v-model="detailForm.rmk2"
									@input="value => onChangeParam({ key: 'rmk2', value })"
									maxlength="33"
									:show-word-limit="true"
								/>
							</td>
						</tr> -->
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import ImgUpload from '@qms/Components/ImgUpload.vue';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false,
			isDisabled: 2,
			normImgFileUrl: '',
			badImgFileUrl: '',
			normImgFileNm: '',
			badImgFileNm: ''
		};
	},
	components: { ImgUpload, FileUploadList },
	computed: {
		...rootComputed,
		...serviceComputed,
		overInspect() {
			return false;
			// 임시저장, 반려, 등록 상태 일 때,
			//return Number(this.detailForm.pgsStCd) >= 30 || this.detailForm.ssId !== this.detailForm.rgnId;
		},
		// 진행상태에 따른 edit여부   
		getEditChk() {
			let editYn = false;
			const pgsStCd = this.detailForm.pgsStCd;
			if (pgsStCd !== undefined && Number(pgsStCd) > 10) {
				editYn = true;
			}
			//console.log('PopupFormPrbm getEditChk , pgsStCd>>> ', editYn, pgsStCd);
			return editYn;
		}
	},
	async mounted() {
		await this.loadImg();
	},
	watch: {
		detailForm: {
			deep: true,
			handler() {
				// if (this.detailForm.partClCd === '') this.isDisabled = 0;
				// if (this.detailForm.partClCd === 'FL') this.isDisabled = 1;
				// if (this.detailForm.partClCd === 'RC') this.isDisabled = 2;
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		imgDupCheck({ seq, file }) {
			let isDup;
			if (seq === 'normImgFile') {
				this.normImgFileNm = file.name;
				// console.log('1 ::: ', seq, this.normImgFileNm, file.name);
			} else {
				this.badImgFileNm = file.name;
				// console.log('2 ::: ', seq, this.badImgFileNm, file.name);
			}

			if (this.normImgFileNm != '' || this.badImgFileNm != '') {
				isDup = this.normImgFileNm == this.badImgFileNm;
			}

			// console.log('isDup >>> ', isDup);
			if (!isDup) {
				this.$refs[seq + 'Ref'].imgUpload();
			} else {
				this.$sf_toast({ type: 'cancel', title: 'Warning', message: this.getMessage_('QWCC001869') }); //파일 이름이 같을 경우 업로드가 제한됩니다.
			}
		},
		imgUpload({ seq, file }) {
			this.onChangeParam_({ key: seq, value: file });
			this[seq + 'Nm'] = file.name;
		},
		fileUpload(saveList) {
			this.onChangeParam_({ key: 'badFile', value: saveList });
		},
		async imgDownload({ seq }) {
			await this.fileDownload_({ fileId: this.detailForm[seq + 'Id'], fileSeq: 1 });
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		onChangeParam_text(key, value, maxByte) {
			maxByte ? this.onChangeParam({ key, value: getLimitedByteText(value, maxByte) }) : this.onChangeParam({ key, value });
		},
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		imgDelete({ seq }) {
			this[seq + 'Nm'] = '';
			this.onChangeParam_({ key: seq + 'Db', value: null });
			this.onChangeParam_({ key: seq, value: null });
			this.onChangeParam_({ key: seq + 'Id', value: '' });
		},
		async loadImg() {
			this.isLoaded = false;

			const { url: normImgFileUrl } = this.detailForm.normImgFileId
				? await this.imgDownload_({ fileId: this.detailForm.normImgFileId, fileSeq: 1 })
				: '';
			const { url: badImgFileUrl } = this.detailForm.badImgFileId
				? await this.imgDownload_({ fileId: this.detailForm.badImgFileId, fileSeq: 1 })
				: '';
			if (normImgFileUrl) {
				this.normImgFileUrl = normImgFileUrl;
				this.normImgFileNm = this.detailForm.normImgFileDb.origFileName;
			}
			if (badImgFileUrl) {
				this.badImgFileUrl = badImgFileUrl;
				this.badImgFileNm = this.detailForm.badImgFileDb.origFileName;
			}

			this.isLoaded = true;
		},
		initImgAll(seq) {
			//이미지 컴포넌트 초기화
			if (!seq) {
				this.normImgFileUrl = '';
				this.badImgFileUrl = '';
				this.$refs.normImgFileRef?.initImg();
				this.$refs.badImgFileRef?.initImg();
			} else {
				this[seq + 'Url'] = '';
				this[seq + 'Nm'] = '';
				this.$refs[seq + 'Ref'].initImg();
			}
		}
	}
};
</script>

<style></style>
